var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoreVerticalOutline = function SvgMoreVerticalOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-vertical-outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 25.3333C13.3335 26.8 14.5335 28 16.0002 28C17.4668 28 18.6668 26.8 18.6668 25.3333C18.6668 23.8667 17.4668 22.6667 16.0002 22.6667C14.5335 22.6667 13.3335 23.8667 13.3335 25.3333Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.66667C13.3335 8.13333 14.5335 9.33333 16.0002 9.33333C17.4668 9.33333 18.6668 8.13333 18.6668 6.66667C18.6668 5.2 17.4668 4 16.0002 4C14.5335 4 13.3335 5.2 13.3335 6.66667Z",
    fill: "#BBC0C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 16C13.3335 17.4667 14.5335 18.6667 16.0002 18.6667C17.4668 18.6667 18.6668 17.4667 18.6668 16C18.6668 14.5333 17.4668 13.3333 16.0002 13.3333C14.5335 13.3333 13.3335 14.5333 13.3335 16Z",
    fill: "#BBC0C5"
  })))));
};
export default SvgMoreVerticalOutline;